export default __webpack_public_path__ + "static/media/infra-9.a00c5602.webp";